import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const IdealMatchStyles = styled(OnboardingPage)`
  .ideal-match-title {
    margin: 20px 0;
  }

  ion-content {
    --overflow: auto;
    --padding-top: 20px;
    --padding-bottom: 20px;

    &::part(scroll) {
      overflow: auto;
    }
  }
`;
